import { useState, useEffect } from "react";

export default function usePanels() {
  const [showLeftPanel, setShowLeftPanel] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setShowLeftPanel(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { showLeftPanel, setShowLeftPanel };
}
